function toggleMenu(item) {
  item.classList.toggle('active');

  // if (!item.classList.contains('active')) {
  //   const active = document.querySelector('.accordeon__item.active');
  //   if (active != null) {
  //     active.classList.remove('active');
  //   }
  //   item.classList.add('active');
  // } else {
  //   item.classList.remove('active');
  // }
}

function onAccordeonHeaderClick(e) {
  e.preventDefault();
  const item = this.closest('.accordeon__item');
  toggleMenu(item);
}

export default function AccordeonHeaders(header) {
  header.forEach((el) => {
    el.addEventListener('click', onAccordeonHeaderClick);
  });
}
